import * as zod from 'zod';

export const RobotiqTSF85Configuration = zod.object({
  kind: zod.literal('RobotiqTSF85'),
  name: zod.string().default('Tactile Sensor Fingertips'),
});

export type RobotiqTSF85Configuration = zod.infer<
  typeof RobotiqTSF85Configuration
>;

export const ROBOTIQ_TSF85_CONFIGURATION_DEFAULT: RobotiqTSF85Configuration = {
  kind: 'RobotiqTSF85',
  name: 'Tactile Sensor Fingertips',
};
